interface Props {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHead({ kicker, title, desc, align = "left" }: Props) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      <div
        className={`inline-flex items-center gap-2 text-primary-600 text-xs md:text-sm font-medium tracking-wide ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        <span className="w-6 h-px bg-primary-400"></span>
        {kicker}
        <span className="w-6 h-px bg-primary-400"></span>
      </div>
      <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 text-sm md:text-base text-foreground-600 max-w-xl ${align === "center" ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}